import { useField } from 'formik';
import { PlaygroundConfig } from 'modules/Playground/types/playgroundConfig';
import { useEffect } from 'react';
import { COMPATIBLE_LLM_MODEL_TYPES } from '../PlaygroundModelSelector/ModelSelectorConstants';

export const useAutoModeSwitch = () => {
  const [{ value: selectedModel }] = useField<PlaygroundConfig['model']>('model');
  const [, , { setValue: setSelectedType }] = useField<PlaygroundConfig['type']>('type');

  useEffect(() => {
    if (!selectedModel) {
      setSelectedType('chat');
    }

    if (COMPATIBLE_LLM_MODEL_TYPES.includes(selectedModel?.model_type_id ?? '')) {
      setSelectedType('chat');
    } else {
      setSelectedType('vision');
    }
  }, [selectedModel?.id]);
};
